import React, { memo, useState } from 'react';
import { Space, Typography, Empty, Spin, Modal, Button } from 'antd';
import { hapticFeedbackImpactOccurred } from '@telegram-apps/sdk-react';
import { useApp } from '../context/AppContext';
import SubscriptionCard from './SubscriptionCard';

const { Text } = Typography;

const ConfigurationsSection = memo(() => {
  const { subscriptions, loadingStates, deleteSubscription, user, t } = useApp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [subscriptionIdToDelete, setSubscriptionIdToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteSubscription = (subscriptionId) => {
    setSubscriptionIdToDelete(subscriptionId);
    setIsModalOpen(true);
    hapticFeedbackImpactOccurred('light');
  };

  const handleConfirmDelete = async () => {
    if (subscriptionIdToDelete && user) {
      try {
        setIsDeleting(true);
        await deleteSubscription(subscriptionIdToDelete);
        setIsModalOpen(false);
        setSubscriptionIdToDelete(null);
        hapticFeedbackImpactOccurred('heavy');
      } catch (error) {
        console.error('Ошибка удаления подписки:', error);
        // Модальное окно останется открытым чтобы пользователь мог повторить попытку
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const handleCancelDelete = () => {
    setIsModalOpen(false);
    setSubscriptionIdToDelete(null);
    hapticFeedbackImpactOccurred('light');
  };

  // Показываем спиннер если идет загрузка подписок
  if (loadingStates.subscriptions) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Spin size="large" />
        <Text style={{ display: 'block', marginTop: '10px' }}>
          {t('configs_loading')}
        </Text>
      </div>
    );
  }

  // Показываем пустое состояние если нет подписок
  if (!subscriptions || subscriptions.length === 0) {
    return (
      <Empty
        description={t('configs_empty')}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      {/* Список подписок */}
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        {subscriptions.map((subscription) => (
          <SubscriptionCard
            key={subscription.id}
            subscription={subscription}
            onDelete={handleDeleteSubscription}
          />
        ))}
      </Space>

      <Modal
        title={t('configs_delete_title')}
        open={isModalOpen}
        onOk={handleConfirmDelete}
        onCancel={handleCancelDelete}
        footer={[
          <Button key="cancel" onClick={handleCancelDelete} disabled={isDeleting}>
            {t('cancel')}
          </Button>,
          <Button
            key="delete"
            type="primary"
            danger
            onClick={handleConfirmDelete}
            loading={isDeleting}
          >
            {t('delete')}
          </Button>,
        ]}
      >
        <p>{t('configs_delete_confirm')}</p>
      </Modal>
    </Space>
  );
});

ConfigurationsSection.displayName = 'ConfigurationsSection';

export default ConfigurationsSection; 
